import React from 'react';
import PropTypes from 'prop-types';
import { Lightbox } from 'rp-bloodstock-search';
import styles from './RelativesActionsLightbox.scss';

export default function RelativesActionsLightbox({ title, text, open, onClose }) {
    return (
        <Lightbox
            open={open}
            onClose={onClose}
        >
            <div className={styles.lightbox__wrap}>
                <h2 className={styles.lightbox__title}>
                    {title}
                </h2>
                <p className={styles.lightbox__text}>
                    {text}
                </p>
                <button
                    className={`ui-btn ui-btn_primary ui-btn_large ${styles.lightbox__button}`}
                    onClick={onClose}
                >
                    ok
                </button>
            </div>
        </Lightbox>
    );
}

RelativesActionsLightbox.propTypes = {
    title: PropTypes.string.isRequired,
    text: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.node,
    ]),
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
};

RelativesActionsLightbox.defaultProps = {
    text: '',
};




// WEBPACK FOOTER //
// ./src/js/components/Lightbox/RelativesActionsLightbox.jsx